/* tslint:disable */
/* eslint-disable */
/**
 * Twioku-API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PostLiffVideoMultiPartUploadSignedurl200ResponsePartsInner
 */
export interface PostLiffVideoMultiPartUploadSignedurl200ResponsePartsInner {
    /**
     * 
     * @type {number}
     * @memberof PostLiffVideoMultiPartUploadSignedurl200ResponsePartsInner
     */
    partNumber: number;
    /**
     * 
     * @type {string}
     * @memberof PostLiffVideoMultiPartUploadSignedurl200ResponsePartsInner
     */
    signedUrl: string;
}

/**
 * Check if a given object implements the PostLiffVideoMultiPartUploadSignedurl200ResponsePartsInner interface.
 */
export function instanceOfPostLiffVideoMultiPartUploadSignedurl200ResponsePartsInner(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "partNumber" in value;
    isInstance = isInstance && "signedUrl" in value;

    return isInstance;
}

export function PostLiffVideoMultiPartUploadSignedurl200ResponsePartsInnerFromJSON(json: any): PostLiffVideoMultiPartUploadSignedurl200ResponsePartsInner {
    return PostLiffVideoMultiPartUploadSignedurl200ResponsePartsInnerFromJSONTyped(json, false);
}

export function PostLiffVideoMultiPartUploadSignedurl200ResponsePartsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): PostLiffVideoMultiPartUploadSignedurl200ResponsePartsInner {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'partNumber': json['partNumber'],
        'signedUrl': json['signedUrl'],
    };
}

export function PostLiffVideoMultiPartUploadSignedurl200ResponsePartsInnerToJSON(value?: PostLiffVideoMultiPartUploadSignedurl200ResponsePartsInner | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'partNumber': value.partNumber,
        'signedUrl': value.signedUrl,
    };
}

